import React, { useState } from 'react';
import { Phone, WhatsappLogo, Headset, X } from '@phosphor-icons/react';
import { useBranding } from '../lib/branding';

const ContactFab = () => {
  const { branding } = useBranding();
  const [open, setOpen] = useState(false);
  const phone = branding.contact_phone || '+91 93640 19465';
  const waNumber = phone.replace(/\D/g, '');
  return (
    <div className="absolute right-4 z-30" style={{ bottom: 140 }}>
      {open && (
        <div
          className="mb-3 slide-up w-52 ml-auto overflow-hidden"
          style={{
            background: 'rgba(255, 255, 255, 0.78)',
            backdropFilter: 'blur(16px) saturate(180%)',
            WebkitBackdropFilter: 'blur(16px) saturate(180%)',
            borderRadius: 16,
            border: '1px solid rgba(0, 0, 0, 0.08)',
            boxShadow: '0 12px 32px -8px rgba(0, 0, 0, 0.28)',
          }}
        >
          <a href={`tel:${phone}`} className="flex items-center gap-3 px-3 py-2.5 hover:bg-white/60 border-b border-black/10" data-testid="contact-fab-call">
            <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ background: 'var(--pk-cyan)' }}>
              <Phone size={14} weight="fill" color="#fff" />
            </div>
            <div>
              <div className="font-bold text-[12px]">Call us</div>
              <div className="text-[10px] text-neutral-500 font-mono">{phone}</div>
            </div>
          </a>
          <a href={`https://wa.me/${waNumber}`} target="_blank" rel="noreferrer" className="flex items-center gap-3 px-3 py-2.5 hover:bg-white/60" data-testid="contact-fab-whatsapp">
            <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ background: '#25D366' }}>
              <WhatsappLogo size={14} weight="fill" color="#fff" />
            </div>
            <div>
              <div className="font-bold text-[12px]">WhatsApp</div>
              <div className="text-[10px] text-neutral-500">Instant reply</div>
            </div>
          </a>
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        data-testid="contact-fab-toggle"
        aria-label="Contact us"
        className="w-12 h-12 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-105 active:scale-95 ml-auto"
        style={{
          background: open
            ? 'rgba(10, 10, 10, 0.75)'
            : 'color-mix(in srgb, var(--pk-primary) 78%, transparent)',
          color: '#fff',
          backdropFilter: 'blur(14px) saturate(180%)',
          WebkitBackdropFilter: 'blur(14px) saturate(180%)',
          boxShadow: '0 8px 24px -6px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.25)',
          border: '1px solid rgba(255, 255, 255, 0.25)',
        }}
      >
        {open ? <X size={18} weight="bold" /> : <Headset size={20} weight="fill" />}
      </button>
    </div>
  );
};

export default ContactFab;
